import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/ebook';
import { Section } from './Section';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section id="faq" className="bg-cream" data-id="element-44" data-mp="1gcxqckbwz1zs">
      <div className="grid gap-10 lg:grid-cols-[0.7fr_1.3fr] lg:gap-16" data-id="element-45" data-mp="1ge0jz00mfije">
        <div data-id="element-46" data-mp="2e0prtqi08pd6">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-sage-dark" data-id="element-47" data-mp="2dz4vbvc4qwco">
            Preguntas frecuentes
          </p>
          <h2 className="mt-5 font-display text-4xl font-light leading-tight text-ink" data-id="element-48" data-mp="28za7y1rkcowd">
            Antes de empezar
          </h2>
        </div>

        <div className="border-t border-line" data-id="element-49" data-mp="1z3ynd2th4ngp">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="border-b border-line" data-id="element-50" data-mp="skqq3a32iav3" data-mpi={index}>
                <h3 data-id="element-51" data-mp="nmgvp1p63eaj">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left" data-id="element-52" data-mp="nqd1prmtp3zx">
                    <span className="text-base font-medium text-ink" data-id="element-53" data-mp="ki1uld0lbwan">{faq.question}</span>
                    <PlusIcon className={`mt-0.5 h-5 w-5 shrink-0 text-sage-dark transition-transform duration-150 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-54" data-mp="6r6kjxecv95h" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-55" data-mp="1sv8rh4i2okm">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-56" data-mp="3jz9n3h6ol0jj">
                      <p className="max-w-2xl pb-6 pr-10 text-[15px] leading-relaxed text-muted" data-id="element-57" data-mp="1krt541q9fmah">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </Section>;
}